import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../components/dialog/dialog.component';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetSaveCancelComponent } from '../components/bottom-sheet-save-cancel/bottom-sheet-save-cancel.component';
import { BudgetPreissteigerungComponent } from '../pages/budget-preissteigerung/budget-preissteigerung.component';
import { offset } from '@popperjs/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  readonly dialog = inject(MatDialog);                            
  readonly snackBar = inject(MatSnackBar);
  private bottomSheet = inject(MatBottomSheet);

  constructor() { }

  showDialog(message: string, title: string = '', question = '', height: number = 200, width: number = 520): Observable<any> {
    const dialogRef = this.dialog.open(DialogComponent, {
      height: height + 'px',
      width:  width + 'px',
      disableClose: true,
      data: {title: title, message: message, question: question, showCancel: true},
    });

    return dialogRef.afterClosed();
  }

  showInfoDialog(message: string, title: string = '', height: number = 200): Observable<any> {
    const dialogRef = this.dialog.open(DialogComponent, {
      height: height + 'px',
      width: '520px',
      disableClose: true,
      data: {title: title, message: message, showCancel: false},
    });

    return dialogRef.afterClosed();
  }

  showErrorDialog(message: string): Observable<any> {
    message += "\n\nBitte wiederholen Sie den Vorgang. Sollte der Fehler weiterhin auftreten, wenden Sie sich an Ihre IT-Administration.";
    const dialogRef = this.dialog.open(DialogComponent, {
      height: '250px',
      width: '520px',
      disableClose: true,
      data: {title: 'Fehler', message: message, showCancel: false},
    });

    return dialogRef.afterClosed();
  }

  async showMessageSheet(message: string, wait: number = 0, error: boolean = false,  positionVertical: 'top' | 'bottom' = 'bottom', duration: number = 3000) {
    await new Promise(resolve => setTimeout(resolve, wait));
    this.snackBar.open(message, '', { 
      duration: duration,
      verticalPosition: positionVertical,
      panelClass: error ? ['snackbar-error'] : ['snackbar-success']
    });
  }

  showSaveChangesSheet() : MatBottomSheetRef<BottomSheetSaveCancelComponent> {
    const previousElement = document.activeElement as HTMLElement;
    let sheetRef = this.bottomSheet.open(BottomSheetSaveCancelComponent, {
      data: "Wollen Sie die Änderungen wirklich speichern?",
      hasBackdrop: false,
      autoFocus: false,
      restoreFocus: true, // ensures previous focus is restored
      // No focus will be moved to the bottom sheet
    });
  
  sheetRef.afterOpened().subscribe(() => {
        previousElement?.focus();
  });
   return sheetRef;
  }

  showPreissteigerungSheet(offSet: boolean, bezugsjahr: number) : MatBottomSheetRef<BudgetPreissteigerungComponent> {
    let sheetRef = this.bottomSheet.open(BudgetPreissteigerungComponent, {
      data: {title: 'Preissteigerung', offset: offSet, bezugsjahr: bezugsjahr},
      hasBackdrop: false,
      panelClass: 'bottom-sheet-dialog'
    });
    return sheetRef;
  }
}
